import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=08ddb05b&scoped=true&"
import script from "./MainScreen.vue?vue&type=script&lang=js&"
export * from "./MainScreen.vue?vue&type=script&lang=js&"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=08ddb05b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ddb05b",
  null
  
)

export default component.exports